<template>

    <div v-loading="loading">
        <div class="form-box">
            <el-form ref="form" inline :model="queryForm" label-width="80px" style="text-align: center">
                <el-form-item>
                    <el-date-picker v-model="queryForm.createdStart" type="date" format="dd/MM/yyyy"
                                    value-format="yyyy-MM-dd"
                                    placeholder="Start"></el-date-picker>
                </el-form-item>

                <el-form-item>
                    <el-date-picker v-model="queryForm.createdEnd" type="date"
                                    placeholder="End" format="dd/MM/yyyy"
                                    value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>

                <el-button type="primary" @click="loadData" icon="el-icon-search" size="medium" circle></el-button>
                <el-button type="primary" @click="exportData" icon="el-icon-download" size="medium" circle></el-button>
            </el-form>
        </div>
        <el-table
                fit
                stripe
                class="data-table"
                :data="data">
            <el-table-column
                    header-align="center"
                    align="center"
                    v-for="item in [
                        {prop:'doorName',label:'Door Name'},
                        {prop:'visitorName',label:'Visitor Name'},
                        {prop:'visitorContact',label:'Visitor Contact'},
                        {prop:'number',label:'Number of Visitor'},
                        {prop:'phone',label:'Resident contact'},
                        {prop:'unit',label:'Unit'},
                        {prop:'purpose',label:'Purpose'},
                        {prop:'createDate',label:'Date'},
                        {prop:'createTime',label:'Time'},
                    ]"
                    :formatter="item.fmt"
                    :prop="item.prop"
                    :label="item.label"
                    :key="item.label">
            </el-table-column>
        </el-table>
        <div class="page">
            <el-pagination @current-change="loadData"
                           :page-size="page.size"
                           :current-page.sync="page.page"
                           :page-count="page.totalPage"
                           layout="prev, pager, next"
                           :total="data.total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {accessList, accessListExport} from '@/api/PropertyApi'
    import {excelRequestRequest} from "@/utils/ApiUtils"

    export default {
        name: "Access",
        data: function () {
            return {
                dialogVisible: false,
                loading: false,
                queryForm: {},
                data: [],
                page: {'page': 1, 'size': 10, 'totalPage': 1, 'total': 0}
            }
        },
        methods: {
            loadData() {
                this.$pageUtils(this, accessList)
            }, exportData() {
                excelRequestRequest(this, accessListExport);
            }
        },
        mounted() {
            this.loadData()
        }
    }
</script>

<style scoped>

</style>
